import { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { IMPRINT_URL, PRIVACY_URL } from '../../_constants/legal'
import { PortalBrand } from '../PortalBrand'

type PropTypes = {
  children: ReactNode
}

export const PublicLayout = ({ children }: PropTypes) => {
  return (
    <div className={'h-full overflow-y-auto bg-sand'}>
      <header className={'mx-auto flex max-w-6xl flex-col items-start gap-4 px-4 py-6 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8'}>
        <Link to={'/'}>
          <PortalBrand />
        </Link>
        <nav className={'grid w-full grid-cols-2 items-center gap-2 sm:flex sm:w-auto'}>
          <Link
            to={'/registrieren'}
            className={'rounded-full px-4 py-2 text-center text-sm font-semibold text-primary-200 hover:bg-sand-200 focus-visible:outline-2 focus-visible:outline-primary'}
          >
            Registrieren
          </Link>
          <Link
            to={'/login'}
            className={'rounded-full bg-primary-200 px-5 py-2 text-center text-sm font-semibold text-white hover:bg-primary-100 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary'}
          >
            Anmelden
          </Link>
        </nav>
      </header>
      <main className={'mx-auto max-w-6xl px-4 pb-16 sm:px-6 lg:px-8'}>
        {children}
      </main>
      <footer className={'mx-auto flex max-w-6xl gap-6 px-4 pb-10 text-sm text-gray-600 sm:px-6 lg:px-8'}>
        <a
          href={PRIVACY_URL}
          target={'_blank'}
          rel={'noreferrer'}
          className={'hover:text-primary-200 hover:underline'}
        >
          Datenschutz
        </a>
        <a
          href={IMPRINT_URL}
          target={'_blank'}
          rel={'noreferrer'}
          className={'hover:text-primary-200 hover:underline'}
        >
          Impressum
        </a>
      </footer>
    </div>
  )
}
